import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  providers: [NgbDropdownConfig, FormGroupDirective]
})
export class FooterComponent implements OnInit {
  
  @ViewChild('content') content;
  form!: FormGroup;
  currentYear: number = new Date().getFullYear();
  constructor(
    private router: Router,
    private rootFormGroup: FormGroupDirective,
    config: NgbDropdownConfig,
    private authService: MsalService,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder
  ) { config.autoClose = true; }

  ngOnInit(): void {
  
  }

}
